<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Product Status
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectStatusTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'status'"
                [selectedOption]="DefaultselectedOptionType"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-drop-down
                type="bookStatus"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookStatus"
                (dropDownChanged)="updateSelectedDropDown($event)"
                [selectedItems]="selectedDefaultItemsStatus"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td class="v-align-m">
              Published Date
            </td>
            <td style="vertical-align: middle;">
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Contract Status
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectStatusTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'contractStatus'"
                [selectedOption]="DefaultselectedOptionType"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-drop-down
                type="contractStatus"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListContractStatus"
                (dropDownChanged)="updateSelectedDropDown($event)"
                [selectedItems]="selectContractStatusTypeDropDownOptions"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td class="v-align-m">
              Alpha Publication Date
            </td>
            <td style="vertical-align: middle;">
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'alphaPublishedDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                [product]=""
                type="alphaPublishedDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product Id</th>
          <th scope="col">Published Date</th>
          <th scope="col">Alpha Publication Date</th>
          <th scope="col">Status</th>
          <th scope="col">Contract Status</th>
          <th scope="col">Book Type</th>
          <th scope="col">Title</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-10E</th>
          <th scope="col">Number Of Active Contracts</th>
          <th scope="col">Band 1 (%) (eBook)</th>
          <th scope="col">Band 1 (%) (Print)</th>
          <th scope="col">Band 1 (%) (Video)</th>
          <th scope="col">Band 1 (%) (Course)</th>
          <th scope="col">Band 1 (%) (Translation)</th>
          <th scope="col">Band 1 (%) (3rd Party Subscription)</th>
          <th scope="col">Band 1 (%) (PacktLib Subscription)</th>
          <th scope="col">Band 1 (%) (Audiobook)</th>
          <th scope="col">Band 1 (%) (Quizzes)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product?.date?.alpha_publication_date}}</td>
          <td>
            {{(product?.status && product.status.length > 0) ?
            product.status?.[0].format : ''}}
          </td>
          <td>{{product?.contract_status}}</td>
          <td>
            {{(product?.type && product.type.length > 0) ?
            product.type?.[0].format : ''}}
          </td>
          <td>{{product.name}}</td>
          <td>{{product.isbn?.isbn_13}}</td>
          <td>{{product.isbn?.isbn_10}}</td>
          <td>{{product.isbn?.isbn_13e}}</td>
          <td>{{product.isbn?.isbn_10e}}</td>
          <td>{{product.contract.length}}</td>
          <td>{{product?.contract_count_ebook}}</td>
          <td>{{product?.contract_count_print}}</td>
          <td>{{product?.contract_count_video}}</td>
          <td>{{product?.contract_count_course}}</td>
          <td>{{product?.contract_count_trans}}</td>
          <td>{{product?.contract_count_third_party}}</td>
          <td>{{product?.contract_count_packtlib}}</td>
          <td>{{product?.contract_count_audiobook}}</td>
          <td>{{product?.contract_count_quizzes}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
